import {useQuery} from "@tanstack/react-query";
import moment from "moment";

export const fetchMultiple = (containerIds) =>
    new Promise((resolve, reject) => {
        let url = `/data-warehouse/batteries`;
        return axios
            .get(url, {
                params: {
                    container_ids: containerIds,
                },
            })
            .then((result) => resolve(result.data))
            .catch((result) => reject(result));
    });

export const fetchSingles = (battery, filter = null) =>
    new Promise((resolve, reject) => {
        let containerId = battery.container_id;
        let url = `/data-warehouse/batteries/${containerId}/singles`;
        return axios
            .get(url, {
                params: {
                    filter: filter,
                },
            })
            .then((result) => {
                const mergedData = {...result.data, battery};
                resolve(mergedData);
            })
            .catch((error) => reject(error));
    });

export const fetchCharts = (containerId, filter = null) =>
    new Promise((resolve, reject) => {
        let url = `/data-warehouse/batteries/${containerId}/charts`;
        return axios
            .get(url, {
                params: {
                    filter: filter,
                },
            })
            .then((result) => resolve(result.data))
            .catch((result) => reject(result));
    });

export const fetchDevChart = (battery, property, filter = null) =>
    new Promise((resolve, reject) => {
        let url = `/batteries/${battery.id}/dev-data`;
        return axios
            .post(url, {
                ...filter,
                key: property
            })
            .then((result) => resolve(result.data))
            .catch((result) => reject(result));
    });

export const fetchAnnotations = (containerId, filter = null) =>
    new Promise((resolve, reject) => {
        let url = `/batteries/${containerId}/chart-annotations`;
        return axios
            .get(url, {
                params: {
                    from: moment(filter?.from_datetime).format(
                        "YYYY-MM-DDTHH:mm:ss"
                    ),
                    to: moment(filter?.to_datetime).format(
                        "YYYY-MM-DDTHH:mm:ss"
                    ),
                },
            })
            .then((result) => resolve(result.data))
            .catch((result) => reject(result));
    });

export const createAnnotation = ([batteryId, data]) =>
    new Promise((resolve, reject) => {
        console.log("Creating annotation: ", batteryId, data);
        let url = `/batteries/${batteryId}/chart-annotations`;
        return axios
            .post(url, {
                ...data,
            })
            .then((result) => resolve(result.data))
            .catch((result) => reject(result));
    });

export const updateAnnotation = ([batteryId, data]) =>
    new Promise((resolve, reject) => {
        console.log("Updating annotation: ", batteryId, data);
        let url = `/batteries/${batteryId}/chart-annotations/${data.id}`;
        return axios
            .put(url, {
                ...data,
            })
            .then((result) => resolve(result.data))
            .catch((result) => reject(result));
    });

export const removeAnnotation = ([batteryId, annotationId]) =>
    new Promise((resolve, reject) => {
        let url = `/batteries/${batteryId}/chart-annotations/${annotationId}`;
        return axios
            .delete(url)
            .then((result) => resolve(result.data))
            .catch((result) => reject(result));
    });

export const exportData = (batteryId, filters) =>
    new Promise((resolve, reject) => {
        let url = `/batteries/${batteryId}/export`;
        return axios
            .post(url, {
                filters: filters,
            })
            .then((result) => resolve(result.data))
            .catch((result) => reject(result));
    });

export const fetchAlerts = (battery) =>
    new Promise((resolve, reject) => {
        let batteryId = battery.id;
        let url = `/batteries/${batteryId}/alerts`;
        return axios
            .get(url, {
                params: {},
            })
            .then((result) => {
                resolve(result.data);
            })
            .catch((error) => reject(error));
    });

export const useSinglesQuery = (filters, battery) => {
    return useQuery({
        queryKey: ["singles", filters, battery.container_id],
        queryFn: () => fetchSingles(battery, filters),
        enabled: !!battery?.container_id,
    });
};

export const useChartsQuery = (filters, battery) => {
    return useQuery({
        queryKey: ["charts", filters, battery?.container_id],
        queryFn: () => fetchCharts(battery?.container_id, filters),
        enabled: !!battery?.container_id,
    });
};

export const useDevChartQuery = (filters, property, battery, enabled = true) => {
    return useQuery({
        queryKey: ["dev-charts", filters, battery?.container_id, property],
        queryFn: () => fetchDevChart(battery, property, filters),
        enabled: enabled,
    });
}

export const useAnnotationsQuery = (filters, battery) => {
    return useQuery({
        queryKey: [
            "annotations",
            JSON.stringify(filters),
            battery?.container_id,
        ],
        queryFn: () => fetchAnnotations(battery?.container_id, filters),
        enabled:
            !!battery?.container_id &&
            !!filters?.from_datetime &&
            !!filters?.to_datetime,
    });
};

export const useAlertQuery = (battery) => {
    return useQuery({
        queryKey: ["alerts", battery.id],
        queryFn: () => fetchAlerts(battery),
        enabled: !!battery?.container_id,
    });
};

export const fetchActivityLogs = (batteryId, filters) => {
    return new Promise((resolve, reject) => {
        let url = `/batteries/${batteryId}/logs`;

        return axios
            .get(url, {
                params: {
                    ...filters,
                },
            })
            .then((result) => resolve(result.data))
            .catch((result) => reject(result));
    });
};

export const useActivityLogsQuery = (batteryId, filters) => {
    return useQuery({
        queryKey: ["activity-logs", batteryId, JSON.stringify(filters)],
        queryFn: () => fetchActivityLogs(batteryId, filters),
        enabled: !!batteryId,
    });
};
